export default __webpack_public_path__ + "static/media/border_radius_16px.66efa6c4.svg";